
        <span i18n="@@questions.phone.number">Questions? Please don’t hesitate to call us: {{getTelephoneNumber()}}</span>
    